import { render, staticRenderFns } from "./FindPasw.vue?vue&type=template&id=ed82eac2&scoped=true"
import script from "./FindPasw.vue?vue&type=script&lang=js"
export * from "./FindPasw.vue?vue&type=script&lang=js"
import style0 from "./FindPasw.vue?vue&type=style&index=0&id=ed82eac2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed82eac2",
  null
  
)

export default component.exports